
// Define standardized selection options for use across the application

export const ageRangeOptions = [
  { value: "13-15", label: "13-15 years" },
  { value: "16-18", label: "16-18 years" },
  { value: "19-22", label: "19-22 years" },
  { value: "23+", label: "23+ years" }
];

export const educationLevelOptions = [
  { value: "middleschool", label: "Middle School" },
  { value: "highschool", label: "High School" },
  { value: "college", label: "College/University" },
  { value: "graduate", label: "Graduate School" },
  { value: "other", label: "Other" }
];

// Re-export the countries array for consistency
export { countries } from './countryList';
